(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["appointedd-embed"] && !Shopify.designMode) return;
  try {
    
  if (document.querySelector('script[data-appointedd-booking-tool]')) {
    return
  }

  const script = document.createElement('script')
  script.src =
    'https://booking-tools-sdk.appointedd.com/appointedd-booking-tools-sdk-v1.js'
  script.async = true
  script.setAttribute('data-appointedd-booking-tool', '')

  document.head.appendChild(script)

  } catch(e) { console.error(e); }
})();
})();
